export default function () {
  // Scroll breadcrumbs by some large number so that the last breadcrumb is visible on mobile
  $('.breadcrumbs__content').scrollLeft(2000)
}
